export default __webpack_public_path__ + "static/media/Look on Hong kong.5efb1bfb.jpg";